import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Helmet } from "react-helmet";
import BlogLayout from "@/components/blog/BlogLayout";
import { BlogContent } from "@/components/blog/BlogContent";
import { useBlogPost } from "@/hooks/useBlogPost";
import { Button } from "@/components/ui/button";
import { ContentLoader } from "@/components/ContentLoader";

const BlogPost = () => {
  const { slug = "" } = useParams();
  const { data: post, isLoading, error } = useBlogPost(slug);

  return (
    <BlogLayout showBreadcrumbs>
      {post && (
        <Helmet>
          <title>{post.title} | Your Company</title>
          <meta name="description" content={post.excerpt || "Read our latest blog post"} />
        </Helmet>
      )}

      <div className="w-full max-w-4xl mx-auto px-4 py-8">
        <Link to="/blog">
          <Button variant="ghost" className="mb-8">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Blog
          </Button>
        </Link>

        <ContentLoader isLoading={isLoading} error={error instanceof Error ? error : null}>
          {post && <BlogContent post={post} />}
        </ContentLoader>
      </div>
    </BlogLayout>
  );
};

export default BlogPost;
